'use strict';

/**
 * Renders a modal window that will track the users consenting to accepting site tracking policy
 */
function showConsentModal() {
    if (!$('.tracking-consent').data('caonline')) {
        return;
    }
    var urlContent = $('.tracking-consent').data('url');
    var urlAccept = $('.tracking-consent').data('accept');
    var htmlString = '<div id="consent-tracking" style="position:sticky"></div>';

    $('body').append(htmlString);

    $.ajax({
        url: urlContent,
        type: 'get',
        dataType: 'html',
        success: function (response) {
            $('#consent-tracking').html(response);
            $('#consent-tracking').find('.accept-cookie-btn').attr('data-url', urlAccept);

            $('.accept-cookie-btn').on('click', function (e) {
                e.preventDefault();
                var url = $(this).data('url');
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function () {
                        $('#consent-tracking').remove();
                        $.spinner().stop();
                    },
                    error: function () {
                        $('#consent-tracking').remove();
                        $.spinner().stop();
                    }
                });
            });
        },
        error: function () {
            $('#consent-tracking').remove();
        }
    });
}

/**
 * Function to set consent tracking for OneTrust banner
 * @param {boolean} trackingConsent - Tracking Consent.
 */
function oneTrustCookieConsent(trackingConsent) {
    var urlAccept = $('.tracking-consent').data('accept');
    var urlReject = $('.tracking-consent').data('reject');
    var consentURL = (trackingConsent ? urlAccept : urlReject);

    try {
        $.ajax({
            url: consentURL,
            type: 'get',
            dataType: 'json'
        });
    } catch (e) { // eslint-disable-line
    }
}

module.exports = function () {
    if ($('.consented').length === 0 && $('.tracking-consent').hasClass('api-true')) {
        showConsentModal();
    }

    if ($('.tracking-consent').hasClass('api-true')) {
        $('.tracking-consent').click(function () {
            showConsentModal();
        });
    }

    $('body').on('click', '#onetrust-reject-all-handler', function (e) {
        e.preventDefault();
        oneTrustCookieConsent(false);
    });

    $('body').on('click', '#onetrust-accept-btn-handler', function (e) {
        e.preventDefault();
        oneTrustCookieConsent(true);
    });
};
